import { useParams } from "react-router";
import { useVbsWorkOrderShowQuery } from "@/services/backend/vbs/work-orders/api/work-order-api";
import { TreatmentComponent } from "@/services/backend/vbs/treatments/components/treatment-component";
import { Column } from "@/services/backend/vbs/treatments/lib/treatment-component-state";
import { isImmutable } from "@/services/backend/documents/lib/document-state";

export function WorkOrderCompletionTreatmentRoute() {
  const { workOrderId } = useParams();
  const { data } = useVbsWorkOrderShowQuery({ id: workOrderId! });

  return (
    <TreatmentComponent
      treatmentId={data!.treatmentId}
      disabled={isImmutable(data!)}
      defaultColumns={[
        Column.Position,
        Column.Completed,
        Column.ComponentKind,
        Column.ComponentData,
        Column.ActuallyTreated,
        Column.Comment,
        Column.Actions,
      ]}
    />
  );
}
